import styled from 'styled-components/native';

import {
  neutralDark,
  neutralLight,
  warrior,
  white,
} from '../../constants/color';
import Image from '../Image';

export default {
  Receipt: styled.View`
    border-radius: 3px;
    border-style: solid;
    border-width: 1px;
    border-color: ${neutralLight};
    background-color: ${white};
  `,
  Container: styled.View`
    margin: 10px;
    margin-bottom: 2px;
    margin-right: 50px;
  `,
  DataItem: styled.View`
    margin-bottom: 8px;
  `,
  Title: styled.Text`
    font-size: 12px;
    line-height: 17px;
    color: ${neutralDark};
  `,
  Value: styled.Text`
    font-size: 15px;
    line-height: 21px;
    color: ${warrior};
  `,
  Barcode: styled(Image)`
    position: absolute;
    top: 10px;
    right: 10px;
    height: 84px;
    width: 30px;
  `,
};
